module.exports = __webpack_public_path__ + "static/media/electric_off.6b8c4d5e.svg";